import React from 'react';
import { formatAmount } from '../../utils/formatters';

const StatCards = ({ stats }) => {
  // Vérifier que financialStats existe
  const financialStats = stats.financialStats || {
    totalDisbursement: 0,
    totalExpected: 0,
    totalReceived: 0,
    totalJewelryWeight: 0,
    totalCDVAWeight: 0,
    totalCDDWeight: 0
  };

  // Calculer le reste
  const remaining = financialStats.totalExpected - financialStats.totalReceived;
  
  // Fonction pour formater les poids avec 2 décimales
  const formatWeight = (weight) => {
    return weight ? weight.toFixed(2) + ' g' : '0.00 g';
  };
  
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-6">
      {/* Carte 1: Nombre total de contrats */}
      <div className="bg-white shadow rounded-lg p-5 border-l-4 border-blue-500 hover:shadow-lg transition-shadow">
        <h3 className="text-sm font-medium text-gray-500">Contrats</h3>
        <p className="text-2xl font-bold text-gray-900 mt-2">{stats.totalContracts || 0}</p>
      </div>
      
      {/* Carte 2: Montant total décaissé */}
      <div className="bg-white shadow rounded-lg p-5 border-l-4 border-green-500 hover:shadow-lg transition-shadow">
        <h3 className="text-sm font-medium text-gray-500">Montant Décaissé</h3>
        <p className="text-2xl font-bold text-green-600 mt-2">{formatAmount(financialStats.totalDisbursement)}</p>
      </div>
      
      {/* Carte 3: Montant total perçu */}
      <div className="bg-white shadow rounded-lg p-5 border-l-4 border-purple-500 hover:shadow-lg transition-shadow">
        <h3 className="text-sm font-medium text-gray-500">Montant Perçu</h3>
        <p className="text-2xl font-bold text-purple-600 mt-2">{formatAmount(financialStats.totalReceived)}</p>
      </div>
      
      
      {/* Carte 4: Montant total prévu */}
      <div className="bg-white shadow rounded-lg p-5 border-l-4 border-indigo-500 hover:shadow-lg transition-shadow">
        <h3 className="text-sm font-medium text-gray-500">Montant Prévu</h3>
        <p className="text-2xl font-bold text-indigo-600 mt-2">{formatAmount(financialStats.totalExpected)}</p>
      </div>
      
      {/* Carte 5: Reste à percevoir */}
      <div className="bg-white shadow rounded-lg p-5 border-l-4 border-red-500 hover:shadow-lg transition-shadow">
        <h3 className="text-sm font-medium text-gray-500">Reste à Percevoir</h3>
        <p className="text-2xl font-bold text-red-600 mt-2">{formatAmount(remaining)}</p>
      </div>
      
      {/* Carte 6: Taux de recouvrement */}
      <div className="bg-white shadow rounded-lg p-5 border-l-4 border-yellow-500 hover:shadow-lg transition-shadow">
        <h3 className="text-sm font-medium text-gray-500">Taux de Recouvrement</h3>
        <p className="text-2xl font-bold text-yellow-600 mt-2">
          {stats.recoveryRate ? `${stats.recoveryRate}%` : '0%'}
        </p>
      </div>




      {/* Carte 7: Totaux des poids */}
      <div className="bg-white shadow rounded-lg p-5 border-l-4 border-amber-500 hover:shadow-lg transition-shadow col-span-1 sm:col-span-2">
        <h3 className="text-sm font-medium text-gray-500 mb-2">Poids Totaux</h3>
        <div className="grid grid-cols-3 gap-2">
          <div>
            <p className="text-xs text-gray-500">Poids Bijou</p>
            <p className="text-lg font-bold text-amber-600">{formatWeight(financialStats.totalJewelryWeight)}</p>
          </div>
          <div>
            <p className="text-xs text-gray-500">Poids CDVA</p>
            <p className="text-lg font-bold text-amber-700">{formatWeight(financialStats.totalCDVAWeight)}</p>
          </div>
          <div>
            <p className="text-xs text-gray-500">Poids CDD</p>
            <p className="text-lg font-bold text-amber-800">{formatWeight(financialStats.totalCDDWeight)}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatCards;